var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import inputSearch from '../console-common/search-input.vue';
import upload from '../console-common/button-import.vue';
export default Vue.extend({
    name: 'violationQueryTrigger',
    components: {
        'el-search-input': inputSearch,
        'el-button-upload': upload,
    },
    computed: __assign({}, mapState('violationManage', {
        timesData: 'timesData',
    }), mapState('common', {
        commonLoading: 'commonLoading',
    })),
    data: function () {
        return {
            ruleTxt: '',
            isHasTimes: true,
            isShowQuery: false,
            isQuery: false,
            uploadEle: '',
            violationParams: {},
            singleForm: {
                engineNumber: '',
                licensePlateNumber: '',
                vehicleIdentificationNumber: '',
            },
            singleRules: {
                licensePlateNumber: [
                    { required: true, message: '请输入车牌号', trigger: 'change' },
                    {
                        required: true,
                        validator: this.licensePlateNumberValidate,
                        trigger: 'blur',
                    },
                ],
                vehicleIdentificationNumber: [
                    { required: true, message: '请输入车架号', trigger: 'blur' },
                    { required: true, message: '请输入车架号', trigger: 'change' },
                ],
                engineNumber: [
                    { required: true, message: '请输入发动机号', trigger: 'blur' },
                    { required: true, message: '请输入发动机号', trigger: 'change' },
                ],
            },
        };
    },
    methods: {
        getUploadEle: function (_a) {
            var uploadEle = _a.uploadEle;
            this.uploadEle = uploadEle;
        },
        toPurchase: function () {
            this.$router.push({
                name: 'violationPurchase',
            });
        },
        payIntroduce: function () {
            this.$alert('<p style="margin-top:20px">每月违章查询免费次数 = 系统中有效车辆数*2。</p><p style="margin-top:10px">有效车辆数 = 已签约车辆+在库车辆数 = 车辆查询页中的车辆总数-已处置车辆数。例如：系统中有效车辆共1000台，则本月可进行2000车次免费违章查询。</p><p style="margin-top:10px">超出部分0.1元/车次。</p>', '费用说明', {
                dangerouslyUseHTMLString: true,
                showConfirmButton: false,
                customClass: 'expenseExplain',
            });
        },
        importVehicle: function () {
            this.$router.push({ name: 'vehicleImport' });
        },
        emitViolationParams: function () {
            var violationParams = this.violationParams;
            this.$emit('get-violation-params', {
                violationParams: violationParams,
            });
        },
        oneClickQuery: function () {
            this.violationParams = {
                source: 'TENANT',
            };
            this.emitViolationParams();
            this.$store.dispatch('common/GET_LOADING');
            this.$store.dispatch('violationManage/GET_PRECALCULATE', {
                data: __assign({}, this.violationParams),
                loadingControl: 'hand',
                loading: this.commonLoading,
            });
        },
        singleQuery: function () {
            this.violationParams = {
                source: 'SINGLE',
            };
            this.emitViolationParams();
            this.isShowQuery = true;
        },
        batchQuery: function () {
            this.violationParams = {
                source: 'UPLOAD',
            };
            this.emitViolationParams();
            this.isShowQuery = true;
        },
        getQueryParams: function () {
            var _this = this;
            var source = this.violationParams.source;
            var commonGet_pre = function () {
                _this.isShowQuery = false;
                _this.$store.dispatch('common/GET_LOADING');
                _this.$store.dispatch('violationManage/GET_PRECALCULATE', {
                    data: __assign({}, _this.violationParams),
                    loadingControl: 'hand',
                    loading: _this.commonLoading,
                });
            };
            if (source === 'SINGLE') {
                this.$refs['singleForm'].validate(function (valid) {
                    if (!valid)
                        return;
                    _this.violationParams = Object.assign(_this.violationParams, _this.singleForm);
                    commonGet_pre();
                    _this.$refs['singleForm'].resetFields();
                });
            }
            if (source === 'UPLOAD') {
                commonGet_pre();
            }
        },
        getViolationRules: function (data) {
            var timesData = data || {};
            var freeConsumeTimes = timesData.freeConsumeTimes, freeTimes = timesData.freeTimes, paidConsumeTimes = timesData.paidConsumeTimes, paidTimes = timesData.paidTimes, totalTimes = timesData.totalTimes;
            var free = freeTimes - freeConsumeTimes, charge = paidTimes - paidConsumeTimes;
            var ruleTxt = '';
            switch (true) {
                case free > 0 && charge <= 0:
                    ruleTxt = "\u4E3A " + freeTimes + "\u6B21\uFF0C\u5DF2\u4F7F\u7528 " + freeConsumeTimes + "\u6B21 \uFF0C\u5269\u4F59\u53EF\u7528 " + free + "\u6B21";
                    break;
                case free > 0 && charge > 0:
                    ruleTxt = "\u4E3A " + freeTimes + "\u6B21\uFF0C\u5DF2\u4F7F\u7528 " + freeConsumeTimes + "\u6B21  \uFF1B \u5DF2\u8D2D\u6B21\u6570\u4E3A " + paidTimes + "\u6B21\uFF0C\u5DF2\u4F7F\u7528 " + paidConsumeTimes + "\u6B21\u3002\u5408\u8BA1\u5269\u4F59\u53EF\u7528 " + totalTimes + "\u6B21";
                    break;
                case free <= 0 && charge > 0:
                    ruleTxt = "\u5747\u5DF2\u4F7F\u7528\u5B8C\u6BD5 \uFF1B\u5DF2\u8D2D\u6B21\u6570\u4E3A " + paidTimes + "\u6B21\uFF0C\u5DF2\u4F7F\u7528 " + paidConsumeTimes + "\u6B21\uFF0C\u5269\u4F59\u53EF\u7528 " + totalTimes + "\u6B21";
                    break;
                case free <= 0 && charge <= 0:
                    ruleTxt = "\u5747\u5DF2\u4F7F\u7528\u5B8C\u6BD5\uFF0C\u5982\u4ECD\u9700\u67E5\u8BE2\u8FDD\u7AE0\uFF0C\u8BF7\u8D2D\u4E70\u67E5\u8BE2\u6B21\u6570\uFF0C0.1\u5143\uFF0F\u6761";
                    this.isHasTimes = false;
                    break;
                default:
                    '';
            }
            this.ruleTxt = ruleTxt;
        },
        getVehicleMsg: function (_a) {
            var _this = this;
            var val = _a.val;
            // 根据车牌号获取车辆信息
            var licensePlateNumber = val;
            this.$request({
                url: '/proxy/vehicle/driver/vehicle/recognition',
                method: 'post',
                data: {
                    licensePlateNumber: licensePlateNumber,
                },
            }).then(function (res) {
                if (!res || res.errorCode)
                    return;
                var _a = res.data, licensePlateNumber = _a.licensePlateNumber, vehicleIdentificationNumber = _a.vehicleIdentificationNumber, engineNumber = _a.engineNumber;
                _this.singleForm.vehicleIdentificationNumber = vehicleIdentificationNumber;
                _this.singleForm.engineNumber = engineNumber;
            });
        },
        clearForm: function () {
            var licensePlateNumber = this.singleForm.licensePlateNumber;
            this.$refs['singleForm'].resetFields();
            this.singleForm.licensePlateNumber = licensePlateNumber;
        },
        getUploadKey: function (params) {
            var uploadKey = params.uploadKey, isQuery = params.isQuery;
            this.violationParams = Object.assign(this.violationParams, {
                redisVehicleInfoCode: uploadKey,
            });
            this.isQuery = isQuery;
        },
        licensePlateNumberValidate: function (rule, value, callback) {
            var re = /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5,6}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4,5})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4,5}[A-HJ-NP-Z0-9挂学警港澳使领]))$/;
            if (re.test(value)) {
                return callback();
            }
            return callback(new Error('车牌号格式不正确'));
        },
        cancelQuery: function () {
            this.isShowQuery = false;
            var source = this.violationParams.source;
            if (source === 'SINGLE') {
                this.$refs['singleForm'].resetFields();
            }
        },
        dialogClose: function () {
            this.isShowQuery = false;
            this.isQuery = false;
            var source = this.violationParams.source;
            if (source === 'SINGLE') {
                this.$refs['singleForm'].resetFields();
            }
        },
    },
    watch: {
        timesData: function (val) {
            this.getViolationRules(val);
        },
        isShowQuery: function (val) {
            var _this = this;
            val &&
                setTimeout(function () {
                    _this.$refs['singleForm'] && _this.$refs['singleForm'].resetFields();
                }, 1);
        },
    },
});
